let cities = [];
let categories = [];

export const priceRanges = [
  { min: 0, max: 100, label: 'Under $100' },
  { min: 100, max: 500, label: '$100 - $500' },
  { min: 500, max: 1000, label: '$500 - $1,000' },
  { min: 1000, max: 5000, label: '$1,000 - $5,000' },
  { min: 5000, max: 10000, label: '$5,000 - $10,000' },
  { min: 10000, max: Infinity, label: 'Over $10,000' }
];

export const updateFilterData = (newCities, newCategories) => {
  cities = newCities;
  categories = newCategories;
};

export const getFilterLabel = (type, id) => {
  switch (type) {
    case 'cities':
      const city = cities.find(c => c.id === id);
      return city ? city.name : '';
    case 'priceRanges':
      return priceRanges[id].label;
    case 'categories':
      const category = categories.find(c => c.id === id);
      return category ? category.name : '';
    default:
      return '';
  }
}; 